module.exports = __webpack_public_path__ + "img/BodmerLkwRight.987ba55.jpg";